import React from "react";
import "../../styles/EmptyState.scss";

const EmptyState = ({ icon, alt = "", text = "Select an item to get started", children }) => (
  <div className="empty-state">
    <div className="empty-state-inner">
      {icon && (
        <img
          src={icon}
          alt={alt}
          className="empty-state-icon"
          draggable={false}
        />
      )}
      <span className="empty-state-text">{text}</span>
      {children}
    </div>
  </div>
);

export default EmptyState;
